import React from "react";
import { Box, Button } from "@mui/joy";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/svgs/logo.svg";
import ThankYouMessage from "./ThankYouMessage";
import SuperApplyCard from "./SuperApplyCard";
import { useDispatch } from "react-redux";
import { fetchPaymentSecret } from "../../redux/applyWorkSlice";
import type { AppDispatch, RootState } from "../../redux/store";
import { useSelector } from "react-redux";
import ReactGA from "react-ga4";

const ThankYou: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const applicant = useSelector((state: RootState) => state.auth.applicant)?.data?.applicant;
  const applicantUuid = applicant?.uuid;
  const userUuid = applicant?.userId;

  const data = localStorage.getItem("applicantData")
    ? JSON.parse(localStorage.getItem("applicantData") as string)
    : null;

  const handleSuperApply = async () => {
    ReactGA.event({
      category: "Super Apply",
      action: "Super Apply Clicked",
      label: "Super Apply Clicked",
    });
    try {
      const resultAction = await dispatch(
        fetchPaymentSecret({ userUuid: userUuid, applicantUuid: applicantUuid })
      );
      if (fetchPaymentSecret.fulfilled.match(resultAction)) {
        navigate("/payment-method", {
          state: { clientSecret: resultAction?.payload?.data?.clientSecret },
        });
      }
    } catch (error) {
      console.error("Failed to fetch payment secret:", error);
    }
  };

  const handleSkipSuperApply = () => {
    ReactGA.event({
      category: "Skip Super Apply",
      action: "Skip Super Apply Clicked",
      label: "Skip Super Apply Clicked",
    });
    navigate("/submission-complete");
    // dispatch(clearApplicant());
  };

  return (
    <Box className="min-h-screen bg-[#f4f4f4] flex flex-col gap-[6rem] px-4 lg:px-6 py-6">
      <Box className="max-w-2xl mx-auto w-full">
        <Box className="mb-4">
          <img src={Logo} alt="logo" className="w-auto h-auto" />
        </Box>

        <ThankYouMessage fullName={data?.fullName} />
        <SuperApplyCard onSuperApply={handleSuperApply} />
      </Box>

      <Box className="w-full px-2 pb-2 lg:px-0">
        <Box className="max-w-2xl mx-auto w-full rounded-lg">
          <Button
            variant="plain"
            color="neutral"
            onClick={handleSkipSuperApply}
            className="w-full !rounded-[16px] !font-semibold !text-base !h-[52px] text-[#2E2D7E] hover:bg-white"
            sx={{
              backgroundColor: "#ffffff",
              border: "none",
              color: "#2E2D7E",
              fontWeight: "bold",
              "&:hover": {
                backgroundColor: "#ffffff",
                border: "none",
              },
            }}
          >
            Skip Super Apply
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ThankYou;
